import { render, staticRenderFns } from "./SectionReviews.vue?vue&type=template&id=6c421b1c"
import script from "./SectionReviews.vue?vue&type=script&lang=js"
export * from "./SectionReviews.vue?vue&type=script&lang=js"
import style0 from "./SectionReviews.vue?vue&type=style&index=0&id=6c421b1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports